module.exports = __webpack_public_path__ + "img/step36_a_printer_power_install_U_frame - Copy.f8c6e9b3.png";